'use strict';
const storeLocatorHelper = require('./storeLocatorHelper');

const init = () => {
    storeLocatorHelper.calculateCurrentlyOpen();
    storeLocatorHelper.getLocation();
    storeLocatorHelper.initMap();
};

module.exports = {
    init: init
};
